import Head from 'next/head'
import { CMS_NAME, CMS_TITLE, CMS_DESC, HOME_OG_IMAGE_URL } from '../lib/constants'
import { GA_TRACKING_ID } from "../components/Analytics";

export default function Meta() {
  return (
    <Head>
      <meta charSet="UTF-8" />
      <link rel="icon" type='image/x-icon' href="/favicons/madaseg_favicon.svg" />
      <meta name="theme-color" content="#3023BD" />
      <meta name="msapplication-navbutton-color" content="#3023BD" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta name="robots" content="index, follow, all" />
      <meta name="geo.region" content="BR-PR" />
      <meta name="geo.placename" content="Ponta Grossa" />
      <meta name="geo.position" content="-25.0962219;-50.1618142" />
      <meta name="ICBM" content="-25.0962219, -50.1618142" />
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:site_name" content={CMS_NAME} />
      <meta property="og:title" key="title" content={CMS_TITLE} />
      <meta property="og:url" content="https://www.madaseg.com.br" />
      <meta property="og:type" content="website" />
      <meta name="description" content={CMS_DESC} />
      <meta property="og:image" content={HOME_OG_IMAGE_URL} />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <script async src={`https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`} />
      <script dangerouslySetInnerHTML={{ __html: `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${GA_TRACKING_ID}', { page_path: window.location.pathname, });`, }} />
    </Head>
  )
}
